import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ColorLogo from "../assets/login/ColorLogo.png";
import logo1 from "../assets/header/HABD.png";
import logo2 from "../assets/login/DMW_Patiala.png";
import api from "../services/AxiosConnection.js";

const DownloadAlarmPDF = async (
  selectedSite,
  selectedSiteName,
  trainDetails,
  setIsLoading
) => {
  try {
    setIsLoading(true);
    if (!selectedSite || !trainDetails?.TrainId) {
      throw new Error("Missing selectedSite or TrainId");
    }

    const user = JSON.parse(localStorage.getItem("user"));
    const userName = user?.username || "Guest";
    const downloadDate = new Date();
    const formattedDateTime = `${downloadDate.toLocaleDateString()} ${downloadDate.toLocaleTimeString()}`;

    const response = await api.get(
      `/simple-view/GetTrainDataByTrainId?siteDb=${selectedSite}&trainId=${trainDetails.TrainId}`
    );
    const { trainTransactions, alarms } = response.data || {};

    const doc = new jsPDF({ orientation: "landscape" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const logoWidth = 18;
    const logoHeight = 15;

    const addHeader = () => {
      doc.setTextColor(0, 0, 0);

      if (ColorLogo) {
        const logoX = 10;
        const logoY = 5;
        const logoW = 35;
        const logoH = logoHeight;

        doc.addImage(ColorLogo, "PNG", logoX, logoY, logoW, logoH);
        doc.link(logoX, logoY, logoW, logoH, {
          url: "https://noviusrailtech.com/",
        });
      }

      if (logo2) {
        doc.addImage(
          logo2,
          "PNG",
          pageWidth - logoWidth - 10,
          5,
          logoWidth,
          logoHeight
        );
      }

      const titleText =
        "NOVIUS HABD (Lite) - NOVIUS HOT AXLE BOX DETECTION SYSTEM (LITE MODEL)";
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");

      const textWidth = doc.getTextWidth(titleText);
      const centerX = pageWidth / 2;
      const offsetX = 20;
      const textX = centerX - textWidth / 2 + offsetX;

      if (logo1) {
        const logo1X = textX - logoWidth - 4;
        doc.addImage(logo1, "PNG", logo1X, 5, logoWidth, logoHeight);
      }

      doc.text(titleText, textX, 15);
      doc.setDrawColor(200, 200, 200);
      doc.line(10, 22, pageWidth - 10, 22);
    };

    const addFooter = () => {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        const pageStr = `Page ${i} of ${pageCount}`;
        doc.text(
          pageStr,
          pageWidth - 14 - doc.getTextWidth(pageStr),
          pageHeight - 10
        );

        doc.setTextColor(80);
        doc.setFont("helvetica", "italic");
        const footerText = `Downloaded by: ${userName} | Download Time: ${formattedDateTime}`;
        doc.text(footerText, 14, pageHeight - 10);
      }
    };

    addHeader();

    let lastTableY = 40;

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`Site: ${selectedSiteName || "N/A"}`, 14, lastTableY);
    lastTableY += 15;

    if (trainTransactions?.length > 0) {
      const train = trainTransactions[0];
      const formattedTrainId = formatPdfDate(train.TrainId);
      const trainName =
        train.TrainName && train.TrainName !== "Train Name"
          ? train.TrainName
          : "N/A";
      const trainNumber =
        train.TrainNumber && train.TrainNumber !== "Train Number"
          ? train.TrainNumber
          : "N/A";

      doc.text("Train Details", 14, lastTableY);
      lastTableY += 10;

      autoTable(doc, {
        startY: lastTableY,
        margin: { left: 10, right: 10 },
        body: [
          [
            {
              content: "Train Date & Time",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: formattedTrainId },
            {
              content: "Train Name",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: trainName },
            {
              content: "Train Number",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: trainNumber },
            {
              content: "Direction",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: train.Direction || "N/A" },
          ],
          [
            {
              content: "Average Speed",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            {
              content: train.AvgSpeed ? Number(train.AvgSpeed).toFixed(2) : "N/A",
            },
            {
              content: "Number of Coaches",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: train.NoBogi || "N/A" },
            {
              content: "Number of Locos",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: train.NoLoco || "N/A" },
            {
              content: "Atmospheric Temp (°C)",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            {
              content: train.AtmosphereTemp
                ? Number(train.AtmosphereTemp).toFixed(2)
                : "N/A",
            },
          ],
          [
            {
              content: "Number of Axles",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: train.TotalNoOfAxles || "N/A" },
            {
              content: "Max Axle Temp Diff (°C)",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            {
              content: train.Max_Avg_Temp_Diff
                ? Number(train.Max_Avg_Temp_Diff).toFixed(2)
                : "N/A",
            },
            {
              content: "Max Avg Axle Temp (°C)",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            {
              content: train.Max_Avg_Axle_Temp
                ? Number(train.Max_Avg_Axle_Temp).toFixed(2)
                : "N/A",
            },
            {
              content: "Coach Type",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: train.Description || "N/A" },
          ],
        ],
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 3,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          halign: "center",
          valign: "middle",
        },
        columnStyles: {
          0: { cellWidth: 34.625 },
          1: { cellWidth: 34.625 },
          2: { cellWidth: 34.625 },
          3: { cellWidth: 34.625 },
          4: { cellWidth: 34.625 },
          5: { cellWidth: 34.625 },
          6: { cellWidth: 34.625 },
          7: { cellWidth: 34.625 },
        },
        didDrawPage: addHeader,
        didDrawTable: (data) => {
          // console.log("Train Details finalY:", data.table.finalY);
        },
      });
    } else {
      doc.text("No train transaction data available", 14, lastTableY);
    }

    if (alarms?.length > 0) {
      doc.addPage();
      addHeader();
      lastTableY = 40;

      // console.log("Rendering Alarm Details, alarms:", alarms, "lastTableY:", lastTableY);
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("Alarm Details", 14, lastTableY);
      lastTableY += 10;

      const alarmColumns = [
        { content: "Axle No", styles: { halign: "center" } },
        { content: "Coach Position", styles: { halign: "center" } },
        { content: "Coach Number", styles: { halign: "center" } },
        { content: "Side", styles: { halign: "center" } },
        { content: "Temperature (°C)", styles: { halign: "center" } },
      ];
      // console.log("Alarm Columns:", alarmColumns.length);

      const alarmBody = alarms.map((alarm) => [
        { content: alarm.AxelNo || alarm.AxleNo || "N/A" },
        { content: alarm.CoachPosition || "N/A" },
        { content: alarm.CoachNo || "N/A" },
        { content: alarm.Side || "N/A" },
        {
          content: alarm.Temperature
            ? Number(alarm.Temperature).toFixed(2)
            : "N/A",
        },
      ]);

      autoTable(doc, {
        startY: lastTableY,
        margin: { top: 40, left: 10, right: 10 },
        head: [alarmColumns],
        body: alarmBody,
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 3,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          halign: "center",
          valign: "middle",
        },
        headStyles: {
          fillColor: [220, 220, 220],
          textColor: [0, 0, 0],
          fontStyle: "bold",
        },
        didDrawPage: addHeader,
        didDrawTable: (data) => {
          // console.log("Alarm Details finalY:", data.table.finalY);
        },
      });
    } else {
      doc.addPage();
      addHeader();
      lastTableY = 40;
      doc.text("No alarm data available", 14, lastTableY);
    }

    addFooter();
    doc.save(`Train_Alarms_${trainDetails.TrainId}.pdf`);
  } catch (error) {
    console.error("Error generating Alarm PDF:", error);
    alert(`Failed to generate Alarm PDF: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};

const formatPdfDate = (trainId) => {
  if (!trainId) return "N/A";
  const parts = trainId.split("T");
  if (parts.length !== 2) {
    const [year, month, day, hour, minute] = trainId.split("_").slice(0, 5);
    return `${day}/${month}/${year} ${hour}:${minute}`;
  }
  const [datePart, timePart] = parts;
  const [year, month, day] = datePart.split("_");
  const [hour, minute] = timePart.split("_").slice(0, 2);
  return `${day}/${month}/${year} ${hour}:${minute}`;
};

export default DownloadAlarmPDF;